export var eBranches;
(function (eBranches) {
    eBranches[eBranches["Soccer"] = 1] = "Soccer";
    eBranches[eBranches["Basketball"] = 2] = "Basketball";
    eBranches[eBranches["Football"] = 3] = "Football";
    eBranches[eBranches["Tennis"] = 6] = "Tennis";
    eBranches[eBranches["Baseball"] = 7] = "Baseball";
    eBranches[eBranches["IceHockey"] = 8] = "IceHockey";
    eBranches[eBranches["Specials"] = 9] = "Specials";
    eBranches[eBranches["Handball"] = 10] = "Handball";
    eBranches[eBranches["RugbyLeague"] = 11] = "RugbyLeague";
    eBranches[eBranches["Golf"] = 12] = "Golf";
    eBranches[eBranches["SnookerAndPool"] = 13] = "SnookerAndPool";
    eBranches[eBranches["MotorRacing"] = 14] = "MotorRacing";
    eBranches[eBranches["Darts"] = 15] = "Darts";
    eBranches[eBranches["Cycling"] = 16] = "Cycling";
    eBranches[eBranches["Poker"] = 17] = "Poker";
    eBranches[eBranches["Speedway"] = 18] = "Speedway";
    eBranches[eBranches["Volleyball"] = 19] = "Volleyball";
    eBranches[eBranches["Boxing"] = 20] = "Boxing";
    eBranches[eBranches["Athletics"] = 21] = "Athletics";
    eBranches[eBranches["Cricket_"] = 22] = "Cricket_";
    eBranches[eBranches["Hockey"] = 23] = "Hockey";
    eBranches[eBranches["Floorball"] = 24] = "Floorball";
    eBranches[eBranches["Futsal"] = 25] = "Futsal";
    eBranches[eBranches["TableTennis"] = 26] = "TableTennis";
    eBranches[eBranches["Bowls"] = 27] = "Bowls";
    eBranches[eBranches["WinterSports"] = 28] = "WinterSports";
    eBranches[eBranches["Hurling"] = 29] = "Hurling";
    eBranches[eBranches["Sailing"] = 30] = "Sailing";
    eBranches[eBranches["WaterPolo"] = 31] = "WaterPolo";
    eBranches[eBranches["BeachVolleyball"] = 32] = "BeachVolleyball";
    eBranches[eBranches["BeachSoccer"] = 33] = "BeachSoccer";
    eBranches[eBranches["Badminton"] = 34] = "Badminton";
    eBranches[eBranches["RugbyUnion"] = 35] = "RugbyUnion";
    eBranches[eBranches["Trotting"] = 36] = "Trotting";
    eBranches[eBranches["Curling"] = 37] = "Curling";
    eBranches[eBranches["OlympicGames"] = 38] = "OlympicGames";
    eBranches[eBranches["Bandy"] = 39] = "Bandy";
    eBranches[eBranches["BeachHandball"] = 40] = "BeachHandball";
    eBranches[eBranches["AussieRules"] = 41] = "AussieRules";
    eBranches[eBranches["WinterOlympic"] = 42] = "WinterOlympic";
    eBranches[eBranches["MMA"] = 43] = "MMA";
    eBranches[eBranches["Shooting"] = 44] = "Shooting";
    eBranches[eBranches["Swimming"] = 45] = "Swimming";
    eBranches[eBranches["Gymnastics"] = 46] = "Gymnastics";
    eBranches[eBranches["Rowing"] = 47] = "Rowing";
    eBranches[eBranches["Triathlon"] = 48] = "Triathlon";
    eBranches[eBranches["Kayak"] = 49] = "Kayak";
    eBranches[eBranches["Judo"] = 50] = "Judo";
    eBranches[eBranches["Wrestling"] = 51] = "Wrestling";
    eBranches[eBranches["Archery"] = 52] = "Archery";
    eBranches[eBranches["Diving"] = 53] = "Diving";
    eBranches[eBranches["Equestrian"] = 54] = "Equestrian";
    eBranches[eBranches["Fencing"] = 55] = "Fencing";
    eBranches[eBranches["ModernPenthathlon"] = 56] = "ModernPenthathlon";
    eBranches[eBranches["Taekwondo"] = 57] = "Taekwondo";
    eBranches[eBranches["Weightlifting"] = 58] = "Weightlifting";
    eBranches[eBranches["Cricket"] = 59] = "Cricket";
    eBranches[eBranches["Surfing"] = 60] = "Surfing";
    eBranches[eBranches["HorseRacing"] = 61] = "HorseRacing";
    eBranches[eBranches["VirtualSports"] = 62] = "VirtualSports";
    eBranches[eBranches["Netball"] = 63] = "Netball";
    eBranches[eBranches["eSports"] = 64] = "eSports";
    eBranches[eBranches["Chess"] = 65] = "Chess";
    eBranches[eBranches["GreyHoundsRacing"] = 66] = "GreyHoundsRacing";
    eBranches[eBranches["GaelicFootball"] = 67] = "GaelicFootball";
    eBranches[eBranches["GaelicHurling"] = 68] = "GaelicHurling";
    eBranches[eBranches["SoccerPromotions"] = 69] = "SoccerPromotions";
    eBranches[eBranches["VirtualSports_"] = 70] = "VirtualSports_";
    eBranches[eBranches["Racketlon"] = 71] = "Racketlon";
    eBranches[eBranches["VirtualSports3Way"] = 73] = "VirtualSports3Way";
    eBranches[eBranches["VirtualSports2Way"] = 75] = "VirtualSports2Way";
    eBranches[eBranches["Casino"] = 99] = "Casino";
})(eBranches || (eBranches = {}));
//# sourceMappingURL=Branches.js.map